/*=========================================================================================
  File Name: module-usertax-mutations.js
  Description: UserTax Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */
import defaultState from './module-role-state';

export default {
	/**
	 * Reset lại trạng thái của state
	 * @param {State} state
	 */
	resetState(state) {
		Object.assign(state, defaultState);
	},

	updateRolesLoaded(state, data) {
		state.RolesLoaded = data;
	},

	updateRoles(state, res) {
		state.Roles.removeAll();
		state.Roles.append(res.Data.Data);
	},

	deleteRole(state, item) {
		state.Roles.remove(item);
		state.Total -= 1;
	},

	updateAllRoles(state, res) {
		state.AllRoles.removeAll();
		state.AllRoles.append(res.Data);
	},

	updateTotalPage(state, res) {
		state.Total = res || 0;
	},

	updateLoadingTotalRecords(state, res) {
		state.IsLoadingTotalRecords = res;
	},
	updateRoleCallback(state, res) {
		state.Roles = res || [];
	}
};
